import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { SharedModule } from 'avn/shared/shared.module';

import { CategoryDescriptionComponent } from './category-description/category-description.component';
import { CategoryFaqComponent } from './category-faq/category-faq.component';
import { CategoryGroupComponent } from './category-group/category-group.component';
import { CategoryHomeComponent } from './category-home/category-home.component';
import { CategoryOtherLocationsComponent } from './category-other-locations/category-other-locations.component';
import { CategoryProviderItemComponent } from './category-provider-item/category-provider-item.component';
import { CategoryRelatedBlogsComponent } from './category-related-blogs/category-related-blogs.component';
import { CategoryRoutingModule } from './category-routing.module';

@NgModule({
  declarations: [
    CategoryHomeComponent,
    CategoryProviderItemComponent,
    CategoryFaqComponent,
    CategoryDescriptionComponent,
    CategoryOtherLocationsComponent,
    CategoryRelatedBlogsComponent,
    CategoryGroupComponent
  ],
  imports: [CommonModule, CategoryRoutingModule, MatExpansionModule, SharedModule]
})
export class CategoryModule {}
